import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface SurveyState {
  preSurveyId: string | null
  postSurveyId: string | null
  loaded: boolean
}

export const surveyInitialState: SurveyState = {
  preSurveyId: null,
  postSurveyId: null,
  loaded: false
}

export const surveySlice = createSlice({
  name: 'survey',
  initialState: surveyInitialState,
  reducers: {
    setSurveyIds: (state, action: PayloadAction<{ preSurveyId: string, postSurveyId: string }>) => {
      state.preSurveyId = action.payload.preSurveyId
      state.postSurveyId = action.payload.postSurveyId
      state.loaded = true
    }
  }
})

export const {
  setSurveyIds
} = surveySlice.actions

export default surveySlice.reducer
